import {DceComponent} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Dce from "dce-engine/lib/decorators/Dce";

interface UiTabsFilterProps {
}

@Dce("UiTabsFilter")
export default class UiTabsFilter extends DceComponent<UiTabsFilterProps> {

    private tabs:HTMLElement[] = [];

    constructor(elem: DceHTMLElement, props: UiTabsFilterProps) {
        super(elem, props);

        elem.querySelectorAll("*[data-filter]").forEach((value, key) => {
            this.tabs.push(value as HTMLElement);

            value.addEventListener('click',e => {
                this.filter(value as HTMLElement);
            })

        });
    }

    private filter(tab: HTMLElement){
        this.tabs.forEach(t => {
            if(t == tab){
                t.classList.add("active");
            }else{
                t.classList.remove("active");
            }
        });

        let f = tab.dataset.filter;
        let parts = f.split(":");

        let selector = "*[data-" + parts[0] + "]";
        let selectorHideOnAll = "*[data-" + parts[0] + "-hide-on-all]";

        if(parts.length < 2 || !parts[1]){
            //show all
            this.elem.querySelectorAll(selector).forEach(v => {
                (v as HTMLElement).style.display = null;
            });

            this.elem.querySelectorAll(selectorHideOnAll).forEach(v => {
                (v as HTMLElement).style.display = 'none';
            });
            return;
        }

        this.elem.querySelectorAll(selector).forEach(v => {

            let row = (v as HTMLElement);

            if(row.dataset[parts[0]] == parts[1]){
                row.style.display = null;
            }else{
                row.style.display = 'none';
            }

        });



    }

}